/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundVariantDto } from '../../models/backend-venture-fund-variant-dto';
import { BackendVentureFundVariantRequestDto } from '../../models/backend-venture-fund-variant-request-dto';

export interface VentureFundsVentureFundVariantsUpdate$FormData$Params {
  id: number;
  body: BackendVentureFundVariantRequestDto;
}

export function ventureFundsVentureFundVariantsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundVariantsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundVariantsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundVariantDto>;
    }),
  );
}

ventureFundsVentureFundVariantsUpdate$FormData.PATH = '/api/venture_funds/venture-fund-variants/{id}/';
